/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

type Dimension = { x: number; y: number; width: number; height: number };

const isOverlap = (L1: number, R1: number, L2: number, R2: number) => L1 <= R2 && L2 <= R1;

/**
 * Checks if the two dimensions are overlapping horizontally.
 * @param dimsA
 * @param dimsB
 * @returns
 */
export function isWidthOverlap(dimsA: Dimension, dimsB: Dimension) {
  return isOverlap(dimsA.x, dimsA.x + dimsA.width, dimsB.x, dimsB.x + dimsB.width);
}

/**
 * Checks if the two dimensions are overlapping vertically.
 * @param dimsA
 * @param dimsB
 * @returns
 */
export function isHeightOverlap(dimsA: Dimension, dimsB: Dimension) {
  return isOverlap(dimsA.y, dimsA.y + dimsA.height, dimsB.y, dimsB.y + dimsB.height);
}
